(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3226],{

/***/ 60677:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mi-cuenta",
      function () {
        return __webpack_require__(83343);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 83343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4351);
/* harmony import */ var ab_account__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46378);
/* harmony import */ var ab_account_details__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13225);
/* harmony import */ var ab_functions_auth__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43700);




// import { getLinkFromTranslation, getLocaleFromContext } from "ab-functions";



var Login = function() {
    var i18n = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("common").i18n;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var authToken = (0,ab_functions_auth__WEBPACK_IMPORTED_MODULE_6__/* .getAuthToken */ .bW)();
        if (!authToken) {
            next_router__WEBPACK_IMPORTED_MODULE_2___default().push("/login");
        }
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_account__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            i18n: i18n,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_account_details__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                i18n: i18n
            })
        })
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Login);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6289,9774,2888,179], function() { return __webpack_exec__(60677); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);